import { render, staticRenderFns } from "./History.vue?vue&type=template&id=4370dc5e&scoped=true&lang=pug"
import script from "./History.vue?vue&type=script&lang=js"
export * from "./History.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4370dc5e",
  null
  
)

export default component.exports